import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import messages from './messages';

type ShiftPlanningIssuesDialog = {
  onClose: () => void;
  isOpen: boolean;
};

export const ShiftPlanningIssuesDialog = (props: ShiftPlanningIssuesDialog) => {
  const intl = useIntl();
  return (
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
      aria-labelledby="shift-planning-issues-dialog-title"
      aria-describedby="shift-planning-issues-dialog-description"
    >
      <DialogTitle id="shift-planning-issues-dialog-title">
        {intl.formatMessage(messages.shiftPlanningIssuesTitle)}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="shift-planning-issues-dialog-description">
          {intl.formatMessage(messages.weekHasUncommittedShifts)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          {intl.formatMessage(messages.close)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ShiftPlanningIssuesDialog.displayName = 'ShiftPlanningIssuesDialog';

export default ShiftPlanningIssuesDialog;
